import { render, staticRenderFns } from "./NewCategoryScreen.vue?vue&type=template&id=2be9b30c&scoped=true&"
import script from "./NewCategoryScreen.vue?vue&type=script&lang=js&"
export * from "./NewCategoryScreen.vue?vue&type=script&lang=js&"
import style0 from "./NewCategoryScreen.vue?vue&type=style&index=0&id=2be9b30c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be9b30c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2be9b30c')) {
      api.createRecord('2be9b30c', component.options)
    } else {
      api.reload('2be9b30c', component.options)
    }
    module.hot.accept("./NewCategoryScreen.vue?vue&type=template&id=2be9b30c&scoped=true&", function () {
      api.rerender('2be9b30c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/budget/NewCategoryScreen.vue"
export default component.exports